import React, { useState } from "react"
import { Button, Card, CardBody, Collapse } from "reactstrap"
import CustomHeaderTitle from "components/Common/CustomHeaderTitle"
import GeneralTables from "components/Common/GeneralTable"
import ActionColumns from "components/Common/GeneralTable/ActionColumns"
import CSAlert from "components/Alert/ConfirmationAlert"
import AdjustmentFilter from "./AdjustmentFilter"
import { downloadURL } from "api/APP_URL"
import AdjustmentOutTotalBox from "./AdjustmentOutTotalBox"
import { getFormatedDate } from "utils/utils"

const AdjustmentListComponent = ({
  data,
  error,
  loading,
  onPageClick,
  onSearch,
  onChangeRowNumber,
  onChangeOrdering,
  onClickDelete,
  onAllDeleteClicked,
  onAdvancedSearchSubmit,
  onClickDetail,
  permissions,
  exportStatus,
  onExportBtnClick,
}) => {
  const [ids, setIds] = useState([])
  const [filterOpen, setFilterOpen] = useState(false)

  const onCheckboxClick = (e, id) => {
    const check = ids.includes(id)
    if (check) {
      const updated = ids.filter(myId => myId !== id)
      setIds(updated)
    } else {
      setIds(prev => {
        return [...prev, id]
      })
    }
  }

  const onAllDeleteHandler = async () => {
    const results = await CSAlert({ title: "Are you sure delete?" })
    if (results.isConfirmed) {
      onAllDeleteClicked(ids)
    }
  }

  const onParentCheckChange = status => {
    if (status) {
      const all = data?.data.map(dt => dt.id)
      setIds(all)
    } else {
      setIds([])
    }
  }

  const onAdvancedSearchHandler = result => {
    setFilterOpen(result)
  }

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <CustomHeaderTitle
            loading={loading}
            title={"List"}
            rowCount={true}
            onChangeRowNumber={onChangeRowNumber}
            orderingList={true}
            onChangeOrdering={onChangeOrdering}
            searchBox={false}
            onSearchHandler={onSearch}
            rightBtn={true}
            rightBtnTitle={"Add Adjustment"}
            rightBtnRoute={"/add-provider-adjustments"}
            deleteBtn={permissions.includes("delete-provider-in")}
            onAllDeleteHandler={onAllDeleteHandler}
            advnacedSearchBtn={true}
            advnacedSearchBtnTitle={"Filter"}
            onAdvancedSearch={onAdvancedSearchHandler}
            exportBtn={true}
            exportBtnLoading={exportStatus?.loading}
            onExportBtnClick={onExportBtnClick}
            orderingOptions={[
              { value: "id", name: "ID" },
              { value: "created_at", name: "Created" },
            ]}
          />

          <Collapse isOpen={filterOpen}>
            <AdjustmentFilter
              loading={loading}
              onAdvancedSearchSubmit={onAdvancedSearchSubmit}
            />
          </Collapse>

          <AdjustmentOutTotalBox totals={data?.totals} />

          <GeneralTables
            data={data?.data}
            loading={loading}
            parentCheckbox={true}
            onParentCheckChange={onParentCheckChange}
            headers={[
              "SN",
              "ITEM CATEGORY",
              "ITEM",
              "BATCH NUMBER",
              "TYPE",
              "QTY",
              "REASON",
              "DATE",
              "Action",
            ]}
            pagination={{ meta: data?.meta, onPageClick: onPageClick }}
            renderItem={(row, index) => (
              <tr key={index}>
                <th scope="row">
                  <div className="form-check form-checkbox-outline form-check-primary mb-3">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={`checkbox-${row.id}`}
                      checked={ids.includes(row.id)}
                      onChange={e => onCheckboxClick(e, row.id)}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`checkbox-${row.id}`}
                    >
                      {data?.meta?.from + index}
                    </label>
                  </div>
                </th>
                <td>{row?.item_category?.name}</td>
                <td>{row?.item?.item_name}</td>
                <td>{row?.provider_in?.batch_number}</td>
                <td>{row?.adjustment_type}</td>
                <td>{row?.qty}</td>
                <td>{row?.reason}</td>
                <td>{row?.date}</td>
                <td>
                  <ActionColumns
                    data={row}
                    enableEdit={false}
                    enableDelete={permissions.includes("delete-provider-in")}
                    enableDetail={true}
                    editRoute={`/edit-provider-adjustments/${row.id}`}
                    onClickDetail={onClickDetail}
                    onClickDelete={onClickDelete}
                    enableDocumentLink={row?.document}
                    documentLink={`${downloadURL}/${row?.document}`}
                  />
                </td>
              </tr>
            )}
          />
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default AdjustmentListComponent
